import { Injectable } from '@angular/core';
import { URLSearchParams } from '@angular/http';
import { Observable } from 'rxjs';
import { Service, HttpMethod } from '../../../domain/model/common/service.class';
import { Page } from '../../../domain/model/common/search/page.class';
import { NotesModel } from '../model/notes.model';

@Injectable()
export class NotesService extends Service {

    constructor(svcm: Service.InjectedMembers) {
        super(svcm, 'adminNotes');
    }

    saveNote(note): Observable<any> {
        return this.call('currentUser', undefined, note, HttpMethod.POST, true);
    }

    getNotesPage(page: number, pageSize: number): Observable<Page<NotesModel>> {
        let params = new URLSearchParams();
        params.set('page', page.toString());
        params.set('size', pageSize.toString());
        return this.getPage(NotesModel, 'currentUser', undefined, params);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/pages/notes/service/notes.service.ts